import React, { useEffect, useState,useRef } from "react";
import CatalogOptions from "../components/CatalogOptions";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

function Admissions() {
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(false);
   const [nameSearch, setNameSearch] = useState("");
    const [contactSearch, setContactSearch] = useState("");
  //const [showModal, setShowModal] = useState(false);
  //const [editingAdmission, setEditingAdmission] = useState(null);
  const [selectedAdmission, setSelectedAdmission] = useState();
  const hasFetched = useRef(false);

  useEffect(() => {
     if (hasFetched.current) return;
      hasFetched.current = true;
    fetchAdmissions();
  }, []);

  const fetchAdmissions = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admissions");
     // const data = await res.json();
      setAdmissions(res.data);
    } catch (err) {
      console.error("Failed to load admissions", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setSelectedAdmission({ ...selectedAdmission, [e.target.name]: e.target.value });
  };
 function handleCatalogChange(field, newValue) {
  setSelectedAdmission(prev => ({
      ...prev,
      [field]: newValue  
    }));
  }


  const openNewAdmission = () => {
     setSelectedAdmission({
      firstName: "",
      lastName:"",
      dob: "",
      gender: "Male",
      nationality: "Indian",
      religion: "Hindu",
      motherTongue: "Telugu",
      address: "",
      prevSchool: "",
      prevClass: "",
      admissionFor: "",
      fatherName: "",
      motherName: "",
      occupation: "",
      qualification: "",
      status:"Pending",
      contact: "",
      email: "",
      income: "",
      notes:""
    });
  };

  const editAdmission = async (id) => {
    try {
      setLoading(true);
       const response = await axiosInstance.get(`/admissions/${id}`);
        if (response.data.status === "SUCCESS") {
             setSelectedAdmission(response.data.data);
        }else{
            if (response.data.message) {
              alert(response.data.message); 
            } else {
              alert(response.message || "Error in Retrieve Class");
            }
        }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const saveAdmission = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/admissions/save", selectedAdmission);
      if (response.data.status === "SUCCESS") {
          alert("Admission Saved Successfully");
          setSelectedAdmission(null);
          fetchAdmissions();
        }else{
             if (response.data.errors && response.data.errors.length > 0) {
              alert(response.data.errors.join("\n")); // show all errors
            } else {
              alert(response.message || "Error in Saving Class");
            }
        }
    } catch (err) {
      console.error(err);
      alert("Error in Save Class");
    } finally {
      setLoading(false);
    }
  };
   // Filtering logic
  const filteredAdmissions = admissions?admissions.filter((adm) => {
    const matchesName =
      adm.studentName.toLowerCase().includes(nameSearch.toLowerCase());

    const matchesContact =
         adm.contact.toLowerCase().includes(contactSearch.toLowerCase());
      //contactSearch === "" || adm.contact === contactSearch;

    return matchesName && matchesContact;
  }):[];
  return (
    <div className="p-4">
       {loading && <Loader />}
      <header className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Admissions</h2>
        <button
          onClick={openNewAdmission}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          New
        </button>
      </header>
    {/* Filters Section */}
      <div className="flex flex-col md:flex-row gap-4 mb-2">

        {/* Name Search */}
        <input
          type="text"
          autoComplete="off"
          placeholder="Search by Name..."
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={nameSearch}
          onChange={(e) => {
            setNameSearch(e.target.value);
           // setCurrentPage(1);
            }}
        />

        {/* Admission Search */}
        <input
          type="text"
          placeholder="Search by Contact..."
          autoComplete="off"
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={contactSearch}
          onChange={(e) => {
            setContactSearch(e.target.value);
           // setCurrentPage(1);
            }}
        />

        {/* Class Dropdown */}
        {/* <select
          className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          value={admissionFilter}
          onChange={(e) => {
            setAdmissionFilter(e.target.value);
            setCurrentPage(1);
            }}
        >
          <option value="">All Classes</option>
          {uniqueClasses.map((cls, index) => (
            <option key={index} value={cls}>
              {cls}
            </option>
          ))}
        </select> */}

      </div>
 <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 text-sm">
          <thead className="bg-gray-100">
            <tr>
              {/* <th className="p-2 border text-left">ID</th> */}
              <th className="p-2 border text-left">Student Name</th>
              <th className="p-2 border text-left">Adm.Number</th>
              <th className="p-2 border text-left">Grade</th>
              <th className="p-2 border text-left">Parent Name</th>
              <th className="p-2 border text-left">Contact</th>
              <th className="p-2 border text-left">Status</th>
              <th className="p-2 border text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            
            {filteredAdmissions.length > 0 ?(
             admissions.map(adm => (
              <tr key={adm.id} className="hover:bg-gray-50">
                {/* <td className="p-2 border">{adm.id}</td> */}
                <td className="p-2 border">{adm.studentName}</td>
                <td className="p-2 border">{adm.admissionNo}</td>
                <td className="p-2 border">{adm.admissionFor}</td>
                <td className="p-2 border">{adm.fatherName}</td>
                <td className="p-2 border">{adm.contact}</td>
                <td className="p-2 border">{adm.status}</td>
                <td className="p-2 border">
                  <button
                    onClick={() => editAdmission(adm.id)}
                    className="bg-green-600 text-white px-2 py-1 rounded"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))): (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No Admissions found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


     {selectedAdmission && (
  <div className="fixed inset-0 z-50 bg-black/50 overflow-y-auto">

    <div className="min-h-screen flex items-start sm:items-center justify-center p-3 sm:p-6">

      <div className="bg-white w-full max-w-lg sm:max-w-2xl lg:max-w-4xl rounded-xl shadow-lg">

        {/* Header */}
        <div className="flex justify-between items-center border-b p-4">
          <h3 className="text-lg font-semibold">
            {selectedAdmission.id ? "Edit Admission" : "New Admission"}
          </h3>

          <button
            onClick={() => setSelectedAdmission(null)}
            className="text-red-500 text-xl font-bold"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-4 max-h-[75vh] overflow-y-auto">

          <div className="space-y-6">

            {/* Student Info */}
            <div>
               {loading && <Loader />}
                <h4 className="font-semibold mb-3">Student Information</h4>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">

                    <div>
                    <label className="block text-sm font-medium mb-1">First Name</label>
                    <input
                        name="firstName"
                        value={selectedAdmission.firstName}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>
                    <div>
                    <label className="block text-sm font-medium mb-1">Last Name</label>
                    <input
                        name="lastName"
                        value={selectedAdmission.lastName}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Date of Birth</label>
                    <input
                        type="date"
                        name="dob"
                        value={selectedAdmission.dob}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Gender</label>
                    <select
                        name="gender"
                        value={selectedAdmission.gender}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    >
                        <option value="">Select</option>
                        <option>Male</option>
                        <option>Female</option>
                    </select>
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Nationality</label>
                    <input
                        name="nationality"
                        value={selectedAdmission.nationality}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Religion</label>
                    <input
                        name="religion"
                        value={selectedAdmission.religion}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Mother Tongue</label>
                    <input
                        name="motherTongue"
                        value={selectedAdmission.motherTongue}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Previous Class</label>
                    <input
                        name="prevClass"
                        value={selectedAdmission.prevClass}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Previous School</label>
                    <input
                        name="prevSchool"
                        value={selectedAdmission.prevSchool}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    

                    <div>
                    <label className="block text-sm font-medium mb-1">Admission For</label>
                    <input
                        name="admissionFor"
                        value={selectedAdmission.admissionFor}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>
                    <div>
                    <label className="block text-sm font-medium mb-1">Status</label>
                    <CatalogOptions
                      name="status"
                      value={selectedAdmission.status}
                      catalogName="AdmissionStatus"
                      onChange={handleCatalogChange}
                      className="border p-2 rounded w-full"
                    />
                    </div>

                    <div className="lg:col-span-2">
                    <label className="block text-sm font-medium mb-1">Address</label>
                    <textarea
                        name="address"
                        value={selectedAdmission.address}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>
                     <div className="lg:col-span-2">
                    <label className="block text-sm font-medium mb-1">Notes</label>
                    <textarea
                        name="notes"
                        value={selectedAdmission.notes}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                </div>
                </div>

            {/* Parent Info */}
           <div>
                <h4 className="font-semibold mb-3">Parent Information</h4>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">

                    <div>
                    <label className="block text-sm font-medium mb-1">Father Name</label>
                    <input
                        name="fatherName"
                        value={selectedAdmission.fatherName}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Mother Name</label>
                    <input
                        name="motherName"
                        value={selectedAdmission.motherName}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Occupation</label>
                    <input
                        name="occupation"
                        value={selectedAdmission.occupation}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Qualification</label>
                    <input
                        name="qualification"
                        value={selectedAdmission.qualification}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Contact Number</label>
                    <input
                        name="contact"
                        value={selectedAdmission.contact}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={selectedAdmission.email}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                    <div>
                    <label className="block text-sm font-medium mb-1">Annual Income</label>
                    <input
                        name="income"
                        value={selectedAdmission.income}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    </div>

                </div>
                </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-2">
              <button
                type="button"
                onClick={() => setSelectedAdmission(null)}
                className="border px-4 py-2 rounded"
              >
                Cancel
              </button>

              <button
                type="submit"
                onClick={saveAdmission}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Save
              </button>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default Admissions;